/**
 * HiddenByRuleMark — WEB-2473 п.2: блок, скрытый правилом «Логики», на холсте
 * конструктора (режим холста, `controlledIndex` у мастера экрана) не
 * пропадает, а рисуется полупрозрачным (0,4) с плашкой «Скрыт правилом
 * «Логики»». Прозрачность — только у самого блока, плашка читается.
 *
 * Общий для мастеров квиза и пейволла. На публичной странице и в `?preview=1`
 * не используется: там скрытый блок не рисуется вовсе. Подпись плашки —
 * ленивый кусок `HiddenByRuleBadge.tsx`: словарь кабинета в первый экран
 * воронки не едет (сторож WEB-2057).
 */
import React, { Suspense } from 'react';
import { lazyWithRetry } from '@/utils/lazyWithRetry';

const HiddenByRuleBadge = lazyWithRetry(
  () => import('./HiddenByRuleBadge'),
  'chunk:hidden-by-rule-badge',
);

const HIDDEN_OPACITY = 0.4;

const wrapStyle: React.CSSProperties = { position: 'relative' };
const bodyStyle: React.CSSProperties = { opacity: HIDDEN_OPACITY };

export function HiddenByRuleMark({
  blockId,
  children,
}: {
  blockId: string;
  children: React.ReactNode;
}) {
  return (
    <div style={wrapStyle} data-testid={`hidden-by-rule-${blockId}`}>
      <Suspense fallback={null}>
        <HiddenByRuleBadge blockId={blockId} />
      </Suspense>
      <div style={bodyStyle} data-testid={`hidden-by-rule-body-${blockId}`}>
        {children}
      </div>
    </div>
  );
}
